module.exports = __webpack_public_path__ + "img/1040046560.ed4e1342.jpg";